// The 58 Algerian wilayas, in official numbering order.
export const WILAYAS = [
	"أدرار",
	"الشلف",
	"الأغواط",
	"أم البواقي",
	"باتنة",
	"بجاية",
	"بسكرة",
	"بشار",
	"البليدة",
	"البويرة",
	"تمنراست",
	"تبسة",
	"تلمسان",
	"تيارت",
	"تيزي وزو",
	"الجزائر",
	"الجلفة",
	"جيجل",
	"سطيف",
	"سعيدة",
	"سكيكدة",
	"سيدي بلعباس",
	"عنابة",
	"قالمة",
	"قسنطينة",
	"المدية",
	"مستغانم",
	"المسيلة",
	"معسكر",
	"ورقلة",
	"وهران",
	"البيض",
	"إليزي",
	"برج بوعريريج",
	"بومرداس",
	"الطارف",
	"تندوف",
	"تيسمسيلت",
	"الوادي",
	"خنشلة",
	"سوق أهراس",
	"تيبازة",
	"ميلة",
	"عين الدفلى",
	"النعامة",
	"عين تموشنت",
	"غرداية",
	"غليزان",
	"المغير",
	"المنيعة",
	"أولاد جلال",
	"برج باجي مختار",
	"بني عباس",
	"إن صالح",
	"إن قزام",
	"تقرت",
	"جانت",
	"تيميمون",
] as const;

// Latin (French) names for the same wilayas, in the SAME order/index as WILAYAS.
// Used to display the list in French/English while the stored value stays the
// canonical Arabic name (WILAYAS[i]).
export const WILAYAS_LATIN = [
	"Adrar",
	"Chlef",
	"Laghouat",
	"Oum El Bouaghi",
	"Batna",
	"Béjaïa",
	"Biskra",
	"Béchar",
	"Blida",
	"Bouira",
	"Tamanrasset",
	"Tébessa",
	"Tlemcen",
	"Tiaret",
	"Tizi Ouzou",
	"Alger",
	"Djelfa",
	"Jijel",
	"Sétif",
	"Saïda",
	"Skikda",
	"Sidi Bel Abbès",
	"Annaba",
	"Guelma",
	"Constantine",
	"Médéa",
	"Mostaganem",
	"M'Sila",
	"Mascara",
	"Ouargla",
	"Oran",
	"El Bayadh",
	"Illizi",
	"Bordj Bou Arréridj",
	"Boumerdès",
	"El Tarf",
	"Tindouf",
	"Tissemsilt",
	"El Oued",
	"Khenchela",
	"Souk Ahras",
	"Tipaza",
	"Mila",
	"Aïn Defla",
	"Naâma",
	"Aïn Témouchent",
	"Ghardaïa",
	"Relizane",
	"El M'Ghair",
	"El Meniaa",
	"Ouled Djellal",
	"Bordj Badji Mokhtar",
	"Béni Abbès",
	"In Salah",
	"In Guezzam",
	"Touggourt",
	"Djanet",
	"Timimoun",
] as const;

// "الحالة / الوضعية" — what the lead currently does. The stored value is the
// canonical Arabic label; display labels per language live in the i18n dict
// (form.jobStatuses), aligned to this same order/index.
export const JOB_STATUSES = [
	"موظف",
	"طالب",
	"صاحب مشروع",
	"مهني حر / حرفي",
	"باحث عن عمل",
	"أخرى",
] as const;

/**
 * Trainings whose audience isn't the general public ask a different question:
 * the Algiers Stock Exchange course wants to know the person's role in their
 * company, not their employment status. Keyed by training slug — a training
 * that isn't listed gets JOB_STATUSES.
 *
 * The stored value stays the Arabic label, like JOB_STATUSES; the fr/en labels
 * are only what the form shows in those languages, so they live here with the
 * list instead of being index-matched into the i18n dict.
 */
export interface JobStatusOption {
	/** Stored on the lead, and shown as-is in Arabic. */
	value: string;
	fr: string;
	en: string;
}

export const JOB_STATUSES_BY_TRAINING: Record<
	string,
	readonly JobStatusOption[]
> = {
	"levee-de-fonds": [
		{
			value: "مسير المؤسسة / مدير عام",
			fr: "Gérant / Directeur général",
			en: "Company manager / CEO",
		},
		{
			value: "محاسب / مدير مالية",
			fr: "Comptable / Directeur financier",
			en: "Accountant / Finance manager",
		},
		{
			value: "صاحب مؤسسة",
			fr: "Propriétaire d'entreprise",
			en: "Business owner",
		},
		{
			value: "صاحب مؤسسة ناشئة ومصغرة",
			fr: "Fondateur de startup ou de micro-entreprise",
			en: "Startup or micro-business founder",
		},
		{
			value: "مهتم بالسوق المالي وبورصة الجزائر",
			fr: "Intéressé par le marché financier et la Bourse d'Alger",
			en: "Interested in the financial market and the Algiers Stock Exchange",
		},
	],
};

/** The list a training's form shows, falling back to the general-public one. */
export function jobStatusesFor(slug: string | null | undefined) {
	return (slug && JOB_STATUSES_BY_TRAINING[slug]) || null;
}
